import { render, staticRenderFns } from "./AbschnittSchwerpunkte.vue?vue&type=template&id=226b78c4&"
import script from "./AbschnittSchwerpunkte.vue?vue&type=script&lang=js&"
export * from "./AbschnittSchwerpunkte.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittSchwerpunkte.vue?vue&type=style&index=0&id=226b78c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports